import React from "react";
import ReactDOM from "react-dom/client";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { ClerkProvider } from "@clerk/clerk-react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { AppProvider } from "providers/appProvider";
import { persistor, store } from "components/common/store/store";
import App from "./app";

import "./app.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { themeSetter } from "localFunctions/themeSetter";
import { detectBrandFromURL } from "components/utils/detectBrands";
import { clerkLocalization } from "lang";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const firebaseAuth = getAuth(app);
const analytics = getAnalytics(app);

export { analytics, firebaseAuth, db };

const { isHarbour, isBiz4Biz, isBiz } = detectBrandFromURL();

themeSetter(isBiz);

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const script = document.createElement("script");
script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`;
script.async = true;
script.defer = true;
document.head.appendChild(script);

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || ""}
        signInUrl={`${process.env.REACT_APP_CLERK_PRIMARY_APP_URL}/sign-in`}
        signUpUrl={`${process.env.REACT_APP_CLERK_PRIMARY_APP_URL}/sign-up`}
        localization={clerkLocalization}
      >
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppProvider isHarbour={isHarbour} isBiz4Biz={isBiz4Biz}>
              <App />
            </AppProvider>
          </PersistGate>
        </Provider>
      </ClerkProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
